export class ParameterNames {
    public static readonly CreditorNo = "CreditorNo";
}